import { getImage } from 'gatsby-plugin-image'
import { decode } from 'html-entities'
import _ from 'lodash'
import React from 'react'
import { Helmet } from 'react-helmet'

import ArticleDefaultImage from '@/assets/images/container-no-image.png'

const absoluteImageUrl = (relativeUrl) => {
  if (relativeUrl && !relativeUrl.startsWith('https://')) {
    return `https://content-hub-static.crypto.com${relativeUrl}`
  }
  return relativeUrl
}

const ArticleSeo = ({ article, category }) => {
  const metaImage = getImage(
    _.get(article, 'featuredImage.node.localFile', undefined)
  )
  const linkCategory = _.get(category, 'description')
  const linkSlug = _.get(article, 'slug')
  const metaLink = `https://crypto.com/${linkCategory}/${linkSlug}`
  const title = _.get(article, 'title')
  const excerpt =
    _.get(article, 'acf.articleExcerpt', '') !== null &&
    _.get(article, 'acf.articleExcerpt', '') !== ''
      ? _.get(article, 'acf.articleExcerpt')
      : _.get(article, 'excerpt')

  return (
    <Helmet
      title={title}
      meta={[
        {
          name: 'twitter:image',
          content: metaImage
            ? absoluteImageUrl(metaImage.images.fallback.src)
            : absoluteImageUrl(ArticleDefaultImage),
        },
        {
          property: 'og:image',
          content: metaImage
            ? absoluteImageUrl(metaImage.images.fallback.src)
            : absoluteImageUrl(ArticleDefaultImage),
        },
        {
          property: 'og:image:width',
          content: metaImage ? metaImage.width : 1200,
        },
        {
          property: 'og:image:height',
          content: metaImage ? metaImage.height : 728,
        },
        {
          property: 'og:image:alt',
          content: title,
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'og:url',
          content:
            typeof window !== 'undefined'
              ? window.location.origin + window.location.pathname
              : '',
        },
        {
          name: 'twitter:url',
          content:
            typeof window !== 'undefined'
              ? window.location.origin + window.location.pathname
              : '',
        },
        {
          name: 'twitter:title',
          content: `${title} | Crypto.com`,
        },
        {
          name: 'twitter:description',
          content: excerpt
            ? decode(excerpt.replace(/<.*?>/g, ''), { level: 'html5' })
            : '',
        },
        {
          name: 'twitter:source',
          content: 'Crypto.com',
        },
        {
          name: 'twitter:site',
          content: 'Crypto.com',
        },
      ]}
    >
      <link rel="canonical" href={metaLink} />
    </Helmet>
  )
}

export default ArticleSeo
